import {baseApi} from './baseApi';

export const injectHereAddressApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getHereAddress: builder.query({
            query:(args, index)=>`getHEREAddressImproving?strassehausnummer=${args.strassehausnummer}&plz=${args.plz}&ort=${args.ort}&index=${args.index}`
        }),
    }),
});

export const {
    useLazyGetHereAddressQuery
} = injectHereAddressApi;
